const STORAGE_KEY = 'kd_notification_manager_unlocked';
export const NOTIFICATION_MANAGER_PASSWORD = '#46vTYv6^%D';

export function isNotificationManagerUnlocked() {
    return sessionStorage.getItem(STORAGE_KEY) === '1';
}

export function setNotificationManagerUnlocked(unlocked) {
    if (unlocked) {
        sessionStorage.setItem(STORAGE_KEY, '1');
    } else {
        sessionStorage.removeItem(STORAGE_KEY);
    }
}

export function notificationManagerHeaders(password = NOTIFICATION_MANAGER_PASSWORD) {
    const loginToken = localStorage.getItem('ACT');
    return {
        Accept: 'application/json',
        Authorization: `Bearer ${loginToken}`,
        'X-Notification-Manager-Password': password,
    };
}
